import { render } from "./SearchSortToggle.vue?vue&type=template&id=7079d8b2&scoped=true"
import script from "./SearchSortToggle.vue?vue&type=script&lang=js"
export * from "./SearchSortToggle.vue?vue&type=script&lang=js"

import "./SearchSortToggle.vue?vue&type=style&index=0&id=7079d8b2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7079d8b2"]])

export default __exports__